import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeaderV2 from "@/components/layout/HeaderV2";
import Footer from "@/components/layout/Footer";

export default function LayoutV2({ children }) {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-[#FDFCFB]">
            <HeaderV2 />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
